import { css } from '@emotion/react';
import { Box, Sheet, styled, Typography } from '@mui/joy';
import { useMap } from '@vis.gl/react-maplibre';
import { useCallback, useEffect, useState } from 'react';

import { useMapAttribution } from '@/hooks/useMapAttribution';
import { MAIN_BREAKPOINT } from '@/modules/MAIN_BREAKPOINT';
import { transientOptions } from '@/utils/transient-options';

const Root = styled(
  Box,
  transientOptions,
)<{ $visible: boolean }>(
  ({ theme, $visible }) => css`
    position: absolute;
    bottom: ${theme.spacing(10)};
    z-index: 1;
    left: 0;
    right: 0;
    padding: 0 ${theme.spacing(2)};
    pointer-events: none;
    display: ${$visible ? 'flex' : 'none'};
    justify-content: center;
    text-align: center;

    ${theme.breakpoints.up(MAIN_BREAKPOINT)} {
      left: auto;
      bottom: 0;
      display: flex;
      padding: 0;
    }
  `,
);

const Content = styled(Sheet)(
  ({ theme }) => css`
    padding: 0 ${theme.spacing(1)};
  `,
);

export function CustomAttributionControl() {
  const [visible, setVisible] = useState(true);

  const { mapAttribution } = useMapAttribution();

  const map = useMap();
  const mapRef = map.current;

  const handleDrag = useCallback(() => {
    setVisible(false);
  }, []);

  useEffect(() => {
    mapRef?.on('drag', handleDrag);

    return () => {
      mapRef?.off('drag', handleDrag);
    };
  }, [handleDrag, mapRef]);

  return mapAttribution.length > 0 ? (
    <Root $visible={visible}>
      <Content>
        <Typography>{mapAttribution.join(' | ')}</Typography>
      </Content>
    </Root>
  ) : null;
}
